// Shared page numbers under a list table: every list shows at most
// PAGE_SIZE (50) rows at once and pages the rest. New tables use this
// (older pages still carry their own copy of the same control).

import { PAGE_SIZE } from '../../hooks/usePaging';

// entry → entries, company → companies, row → rows.
const plural = (w: string) => /[^aeiou]y$/.test(w) ? `${w.slice(0, -1)}ies` : `${w}s`;

export function Paging({ page, totalPages, total, onChange, noun = 'row' }: {
  page: number; totalPages: number; total: number; onChange: (p: number) => void;
  /** What a row is, singular ("entry", "company"…). */
  noun?: string;
}) {
  if (totalPages <= 1) return null;
  const from = (page - 1) * PAGE_SIZE + 1;
  const to   = Math.min(page * PAGE_SIZE, total);
  const pages: (number | 'e')[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (page > 3) pages.push('e');
    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) pages.push(i);
    if (page < totalPages - 2) pages.push('e');
    pages.push(totalPages);
  }
  return (
    <div className="pagination no-print">
      <span className="pagination-info">
        Showing <strong>{from}–{to}</strong> of <strong>{total}</strong> {total === 1 ? noun : plural(noun)}
      </span>
      <div className="pagination-btns">
        <button type="button" className="pg-btn" disabled={page === 1} onClick={() => onChange(page - 1)}>‹</button>
        {pages.map((p, i) => p === 'e'
          ? <span key={`e${i}`} style={{ minWidth: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, color: 'var(--text-3)' }}>…</span>
          : <button type="button" key={p} className={`pg-btn${p === page ? ' active' : ''}`} onClick={() => onChange(p)}>{p}</button>)}
        <button type="button" className="pg-btn" disabled={page === totalPages} onClick={() => onChange(page + 1)}>›</button>
      </div>
    </div>
  );
}
